import { Mixpanel } from './mixpanel'

export const EVENT_ACTIONS = {
  checkout: {
    tier1_monthly: 'IndividualMonthly',
    tier1_lifetime: 'IndividualLifetime',
    tier2_monthly: 'BusinessMonthly',
    tier2_lifetime: 'BusinessLifetime',
    tier3_monthly: 'EnterpriseMonthly',
    tier3_lifetime: 'EnterpriseLifetime',
  },
}

const OK_STATUS = 'ok'
const FAILED_STATUS = 'failed'

export const shouldTrackKeywordUpdateSuccess = (
  keywordsArray,
  updateEvents,
) => {
  const updatedEvents = updateEvents.filter((event) => {
    const { keywords } = event
    if (!keywords) return true

    let failedCount = 0

    const hasCompletedAll = keywords.every(({ keyword }) => {
      const matchingKeyword = keywordsArray.find(
        (keywordSD) =>
          keywordSD.keyword === keyword &&
          (keywordSD.status === OK_STATUS ||
            keywordSD.status === FAILED_STATUS),
      )

      if (matchingKeyword && matchingKeyword.status === FAILED_STATUS) {
        failedCount += 1
      }

      return matchingKeyword
    })

    if (!hasCompletedAll) return true

    Mixpanel.trackUpdateKeywordClickAndSuccess({
      ...event,
      updateCount: event.updateCount - failedCount,
    })
    return false
  })

  return updatedEvents
}
